const forms = {
  onRequest: "تحت الطلب", // translated 
  person: "شخص", // translated 
  travelDate: "تاريخ السفر", // translated 
  travelDates: "مواعيد السفر", // translated 
  cancel: "إلغاء", // translated 
  getPrice: "احصل على السعر", // translated 
};



export default forms;
